import { Link, useLocation } from "react-router-dom";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { useEffect, useState } from "react";
import { FaHandsHelping } from "react-icons/fa";
import { GiLaurelsTrophy } from "react-icons/gi";
import { MdSportsEsports } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";

const VerticalMenu = () => {
    const URL = useLocation();
    const [active_menu, setActiveMenu] = useState(localStorage.getItem("active_menu") ?? "DASHBOARD");

    const PATH_TO_MENU: any = {
        "/dashboard": "DASHBOARD",
        "/manage-admin-user": "MANAGE_ADMIN_USER",
        "/manage-sport": "MANAGE_SPORT",
        "/manage-sponsorship": "MANAGE_SPONSORSHIP"
    };

    const handleMenuClick = (menu: string) => {
        setActiveMenu(menu);
        localStorage.setItem("active_menu", menu);
    };

    useEffect(() => {
        const matchedMenu = PATH_TO_MENU[URL.pathname];
        if (matchedMenu) {
            setActiveMenu(matchedMenu);
            localStorage.setItem("active_menu", matchedMenu);
        }
    }, [URL.pathname]);

    return (
        <>
            <div id="vertical_menu" className="verticle-menu">
                <div className="text-center pb-3">
                    <img src={"Logo"} width={118} alt="" />
                </div>
                <div className="menu-list">
                    <Link
                        id="t-1"
                        to={"/dashboard"}
                        className={
                            active_menu === "DASHBOARD" ? "active menu-item" : "menu-item"
                        }
                        onClick={() => handleMenuClick("DASHBOARD")}
                    >
                        {" "}
                        <MdOutlineSpaceDashboard className="menu-icon" />{" "}
                        <span className="nav-text">Dashboard</span>
                    </Link>
                    <Link
                        id="t-4"
                        to={"/manage-admin-users"}
                        className={
                            active_menu === "MANAGE_ADMIN_USER"
                                ? "active menu-item"
                                : "menu-item"
                        }
                        onClick={() => handleMenuClick("MANAGE_ADMIN_USER")}
                    >
                        {" "}
                        <FaUserCircle className="menu-icon" />{" "}
                        <span className="nav-text">Manage Admin Users</span>
                    </Link>
                    <Link
                        id="t-4"
                        to={"/manage-sport"}
                        className={
                            active_menu === "MANAGE_SPORT"
                                ? "active menu-item"
                                : "menu-item"
                        }
                        onClick={() => handleMenuClick("MANAGE_SPORT")}
                    >
                        <MdSportsEsports className="menu-icon" />{" "}
                        <span className="nav-text">Manage Sports</span>
                    </Link>
                    <Link
                        id="t-6"
                        to={"/manage-sponsorship"}
                        className={
                            active_menu === "MANAGE_SPONSORSHIP"
                                ? "active menu-item"
                                : "menu-item"
                        }
                        onClick={() => handleMenuClick("MANAGE_SPONSORSHIP")}
                    >
                        <FaHandsHelping className="menu-icon" />{" "}
                        <span className="nav-text">Manage Sponsorship</span>
                    </Link>
                </div>
            </div>
        </>
    );
};
export default VerticalMenu;
